import React from 'react';
import GeneralSetting from './GeneralSetting';

export default class GeneralSettingIndex extends React.Component {

    render() {

        return (
            <div className="general-setting" >
                <GeneralSetting {...this.props} />
            </div>
        );
    }
}


